import React, { useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { Alert, useAlert } from 'bootflex'

const Alerts = (props) => {
  //DEFINE ALERTS USING useAlert() HOOK
  const okAlert = useAlert({
    type: 'OK',
    body: <i>This is a basic alert that has no header. The OK button will log to console.</i>,
    props: {
      OK: {
        onClick: ({ hide }) => {
          console.log('OK was clicked')
          hide()
        },
      },
    },
  })
  const yesnoAlert = useAlert({
    header: <h4>PLEASE ANSWER</h4>,
    type: 'YESNO',
    props: {
      YES: {
        onClick: ({ hide }) => {
          console.log('CLICKED YES', hide)
          hide()
        },
      },
    },
  })

  const infoAlert = useAlert({
    header: <h4>Information</h4>,
    body: <i>This is an information Alert</i>,
    type: 'INFO',
    props: {
      modal: {
        size: 'sm',
      },
      CANCEL: {
        onClick: ({ hide }) => {
          console.log('CLICKED CANCEL', hide)
          hide()
        },
      },
    },
  })

  const customAlert = useAlert({
    header: <h4>THIS IS A CUSTOM ALERT</h4>,
    body: <i>There is no predefined buttons for this alert</i>,
    footer: [
      <Button
        key='1'
        variant='secondary'
        onClick={() => {
          console.log('---> CUSTOM ALERT called with', customAlert)
          customAlert.hide()
        }}
      >
        CANCEL
      </Button>,
    ],
  })

  const customAlert2 = useAlert({
    header: <h4>THIS IS A CUSTOM ALERT THIS CHILDREN WITHIN ALERT</h4>,
    body: (
      <i>There is no predefined buttons for this alert. Thery are defined in this case through Alert.Footer child of the Alert parent</i>
    ),
  })

  const nonModalAlert = useAlert({
    type: 'OK',
    body: <i>This is a non modal alert . The OK button will log to console.</i>,
    variant: 'DIALOG',
    props: {
      dialog: {
        className: 'p-0 m-0',
      },
      OK: {
        onClick: ({ hide }) => {
          console.log('OK non modal was clicked')
          hide()
        },
      },
    },
  })

  const confirmAlert = useAlert({
    type: 'CONFIRM',
    variant: 'DIV',
    props: {
      YES: {
        onClick: ({ hide, data, state }) => {
          console.log('Clicked Yes to Confirm', data, state)
          hide()
        },
      },
    },
  })

  const timedAlert = useAlert({
    header: <h4>PLEASE ANSWER</h4>,
    body: 'This alert will clear after 3 seconds',
    type: 'PROCEED',
  })

  useEffect(() => {
    console.log('Custom Alert Change', customAlert)
  }, [customAlert])

  return (
    <div className='p-4'>
      <h4>DEMONSTRATION OF ALERT MODALS</h4>

      {/* BUTTONS TO TEST VARIOUS ALERT OPTIONS */}
      <Button className='m-2' onClick={() => okAlert.show()}>
        ALERT OK
      </Button>
      <Button className='m-2' onClick={() => yesnoAlert.show()}>
        YES NO
      </Button>
      <Button className='m-2' onClick={() => infoAlert.show()}>
        INFO
      </Button>
      <Button
        className='m-2'
        onClick={() => {
          customAlert.show(null, { fuck: 'yeah' })
        }}
      >
        CUSTOM 1
      </Button>
      <Button className='m-2' onClick={() => customAlert2.show()}>
        CUSTOM 2
      </Button>
      <Button className='m-2' onClick={() => nonModalAlert.show()}>
        NON MODAL
      </Button>
      <Button className='m-2' onClick={() => confirmAlert.show()}>
        CONFIRM
      </Button>
      <Button className='m-2' onClick={() => confirmAlert.show(null, { x: 1 })}>
        CONFIRM WITH DATA
      </Button>
      <Button className='bg-warning m-2' onClick={() => console.log('STate', customAlert)}>
        SHOW STATE
      </Button>
      <Button className='m-2' onClick={() => timedAlert.show(3000)}>
        TIMED ALERT
      </Button>

      <div>
        <Alert hook={nonModalAlert} />
      </div>

      {/* ALERT COMPONENTS */}
      <Alert dismiss hook={okAlert} size='lg' />
      <Alert hook={yesnoAlert} size='xl' />
      <Alert hook={infoAlert} />
      <Alert hook={customAlert} />
      <Alert hook={customAlert2}>
        <Alert.Footer>
          <Button>DO SOMETHING</Button>
          <Button
            variant='secondary'
            onClick={() => {
              console.log('Custom Alert Click for CANCE')
              customAlert2.hide()
            }}
          >
            CANCEL
          </Button>
        </Alert.Footer>
      </Alert>
      <Alert hook={confirmAlert} />
      <Alert dismiss hook={timedAlert} />
    </div>
  )
}

export default Alerts
